module.exports = __webpack_public_path__ + "img/technology-23.7e967748.png";